import moment from "moment";

export default (date) => {
    if (!date) return ''
    return moment(date).format("M/D/Y");
};

export const getMonthAbbreviation = (date) => {
    if (!date) return '';
    return moment(date).format("MMM");
}

export const getDayOnly = (date) => {
    if (!date) return '';
    return moment(date).date();
}

export const getYearOnly = (date) => {
    if (!date) return '';
    return moment(date).format("YYYY");
}
